import React, { Component } from 'react'
import { connect } from 'react-redux';
import { getUsuario } from '../usuario/UsuarioService';

class BusquedaUsuario extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            searchResults: [],
            isLoading: false,
            showDropdown: false,
            searchTimeout: null,
            usuariosData: null
        };

        this.searchInputRef = React.createRef();
    }

    fetchUsuarios = (page, pageSize, search) => {
        return this.props.getUsuario(page, pageSize, search).then(() => {
            const { usuariosData } = this.props;
            return {
                items: usuariosData.usuarios,
                totalCount: usuariosData.totalCount,
            };
        });
    };

    handleSearchChange = (event) => {
        const value = event.target.value;
        this.setState({ searchTerm: value });

        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        if (value.length > 0) {
            this.setState({ showDropdown: true, isLoading: true });

            const timeout = setTimeout(() => {
                this.performSearch(value);
            }, 300);

            this.setState({ searchTimeout: timeout });
        } else {
            this.setState({
                searchResults: [],
                showDropdown: false,
                isLoading: false
            });
        }
    };

    performSearch = async (searchTerm) => {
        try {
            this.setState({ isLoading: true });
            const response = await this.fetchUsuarios(0, 5, searchTerm);

            const resultadosFiltrados = response.items.filter(
                (u) => !this.props.selectedUsers.some((sel) => sel.id === u.id)
            );
            this.setState({
                searchResults: resultadosFiltrados,
                isLoading: false
            });
        } catch (error) {
            console.error('Error en la búsqueda:', error);
            this.setState({
                searchResults: [],
                isLoading: false
            });
        }
    };

    handleUserSelect = (user) => {
        // Verificar si el usuario ya está seleccionado
        const isAlreadySelected = this.props.selectedUsers.some(
            selectedUser => selectedUser.id === user.id
        );

        if (!isAlreadySelected) {
            const nuevaLista = [...this.props.selectedUsers, user];
            this.setState({
                searchTerm: '',
                searchResults: [],
                showDropdown: false
            });
            this.props.onSelectedUsersChange(nuevaLista);
        } else {
            // Limpiar campo si el usuario ya está seleccionado
            this.setState({
                searchTerm: '',
                searchResults: [],
                showDropdown: false
            });
        }
    };

    handleClearSearch = () => {
        this.setState({
            searchTerm: '',
            searchResults: [],
            showDropdown: false
        });
        this.searchInputRef.current?.focus();
    };


    handleClickOutside = (event) => {
        if (!event.target.closest('.search-container')) {
            this.setState({ showDropdown: false });
        }
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
    }
    render() {
        const {
            searchTerm,
            searchResults,
            isLoading,
            showDropdown
        } = this.state;

        return (
            <div className="single-select">
                <div className={`ci-search ${showDropdown ? 'searching' : ''} ${searchTerm ? 'has-value' : ''}`}>
                    <input
                        ref={this.searchInputRef}
                        type="text"
                        value={searchTerm}
                        onChange={this.handleSearchChange}
                        placeholder="Buscar por nombre"
                        className="ci-search__input"
                    />

                    <span className={`material-symbols-outlined ci-search__search-icon ${searchTerm ? 'opacity-0' : 'opacity-100'}`}>search</span>
                    <span
                        className={`material-symbols-outlined ci-search__clear ${searchTerm ? 'opacity-100' : 'opacity-0'} hover:text-gray-600 cursor-pointer`}
                        onClick={this.handleClearSearch}
                    >
                        close
                    </span>

                    {/* Dropdown de resultados */}
                    <div className="ci-search__dropdown">
                        {isLoading ? (
                            <div className="ci-search__no-results">
                                <div className="flex items-center justify-center">
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500 mr-2"></div>
                                    Buscando...
                                </div>
                            </div>
                        ) : searchResults.length > 0 ? (
                            searchResults.map((user, index) => {
                                const isSelected = this.props.selectedUsers.some(selected => selected.id === user.id);
                                const isLast = index === searchResults.length - 1;
                                return (
                                    <div
                                        key={user.id}
                                        onClick={() => this.handleUserSelect(user)}
                                        className={`ci-search__option ${isLast ? 'last:border-b-0' : ''} ${isSelected ? 'bg-blue-50' : ''
                                            }`}
                                    >
                                        <div className="ci-search__option-content">
                                            <div className="ci-search__option-name">
                                                {user.nombreApellido}
                                                {isSelected && <span className="ml-2 text-xs text-blue-600">(Ya seleccionado)</span>}
                                            </div>
                                            <div className="ci-search__option-ci">C.I.: {user.cedula}</div>
                                            <div className="ci-search__option-username">Usuario: {user.usuario}</div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : searchTerm.length > 0 ? (
                            <div className="ci-search__no-results">
                                No se encontraron usuarios
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    getUsuario: (page, size, search) => dispatch(getUsuario(page, size, search)),
});

const mapStateToProps = (state) => ({
    usuariosData: state.usuariosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(BusquedaUsuario)